import { createAction, props } from '@ngrx/store';
import { PlantNetworkStatus } from './plant-network-status.models';

// Action to fetch plants
export const fetchPlants = createAction('[Plant Network] Fetch Plants');

// Action for when plants are successfully loaded
export const fetchPlantsSuccess = createAction(
  '[Plant Network] Fetch Plants Success',
  props<{ plants: PlantNetworkStatus[] }>(),
);

// Action for when there is an error loading plants
export const fetchPlantsFailure = createAction('[Plant Network] Fetch Plants Failure', props<{ payload: string }>());

// Action to get the latest plant network status
export const getLatestPlantNetworkStatus = createAction(
  '[Plant Network] Get Latest Plant Network Status',
  props<{ plantCode: string }>(),
);

// Action for when the latest plant network status is successfully retrieved
export const getLatestPlantNetworkStatusSuccess = createAction(
  '[Plant Network] Get Latest Plant Network Status Success',
  props<{ plantCode: string; plant: PlantNetworkStatus }>(),
);

// Action for when the latest plant network status is not successfully retrieved
export const getLatestPlantNetworkStatusFailure = createAction(
  '[Plant Network] Get Latest Plant Network Status Failure',
  props<{ plantCode: string; error: string }>(),
);

export const getLatestPlantsNetworkStatus = createAction(
  '[Plant Network] Get Latest Plants Network Status',
  props<{ plantCodes: string[] }>(),
);

export const getLatestPlantsNetworkStatusSuccess = createAction(
  '[Plant Network] Get Latest Plant Network Status Success',
  props<{ plantCodes: string[]; plants: PlantNetworkStatus[] }>(),
);

export const getLatestPlantsNetworkStatusFailure = createAction(
  '[Plant Network] Get Latest Plant Network Status Failure',
  props<{ plantCodes: string[]; error: string }>(),
);

// Action to update the status of a plant
export const updatePlantStatus = createAction(
  '[Plant Network] Update Plant Status',
  props<{ payload: { PlantCode: string; IsOnline: boolean } }>(),
);

// Action for when the plant status is successfully updated
export const updatePlantStatusSuccess = createAction(
  '[Plant Network] Update Plant Status Success',
  props<{ payload: { PlantCode: string; IsOnline: boolean } }>(),
);

// Action for when there is an error updating the plant status
export const updatePlantStatusFailure = createAction(
  '[Plant Network] Update Plant Status Failure',
  props<{ payload: string }>(),
);

// Action for when the date changes
export const dateChanged = createAction('[Plant Network] Date Changed', props<{ payload: string }>());
